// src/components/AssetSelectionPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AssetSelectionPage = () => {
  const navigate = useNavigate();

  // Mock data for existing NFTs (this could come from an API or blockchain query)
  const [nfts, setNfts] = useState([
    { id: 1, name: "NFT #1", description: "A beautiful digital artwork.", image: "/images/nft1.png" },
    { id: 2, name: "NFT #2", description: "A collectible item.", image: "/images/nft2.png" },
  ]);

  const [selectedNFT, setSelectedNFT] = useState(null);

  const handleSelectNFT = (nft) => {
    setSelectedNFT(nft);
  };

  const handleProceed = () => {
    if (!selectedNFT) {
      alert("Please select an NFT or create a new one.");
      return;
    }
    // Pass selectedNFT to the next page
    navigate("/fractionalization", { state: { selectedNFT } });
  };

  return (
    <div className="asset-selection">
      <h2>Select an Asset</h2>
      <p>Select an NFT from your existing collection or create a new one.</p>

      <div className="nft-gallery">
        {nfts.map((nft) => (
          <div
            key={nft.id}
            className={`nft-card ${selectedNFT?.id === nft.id ? "selected" : ""}`}
            onClick={() => handleSelectNFT(nft)}
          >
            <img src={nft.image} alt={nft.name} />
            <div className="nft-details">
              <h4>{nft.name}</h4>
              <p>{nft.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="actions">
        <button onClick={() => navigate("/minting")}>Create New NFT</button>
        <button onClick={handleProceed} disabled={!selectedNFT}>
          Proceed with Selected NFT
        </button>
      </div>
    </div>
  );
};

export default AssetSelectionPage;
